import { render, staticRenderFns } from "./CodeExampleSource.vue?vue&type=template&id=20979f91&scoped=true"
import script from "./CodeExampleSource.vue?vue&type=script&lang=ts"
export * from "./CodeExampleSource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20979f91",
  null
  
)

export default component.exports